<template>
  <div class="columns">
    <div
        class="column is-full is-flex"
        :class="{
          'is-justify-content-end is-align-content-end' : position === 'right',
          'is-justify-content-center is-align-content-center' : position === 'center'
        }"
    >
      <button
          class="button is-primary is-size-3 is-size-5-mobile is-large has-text-weight-medium next-button"
          :class="[ sizeClass ]"
          @click.prevent="handleClick"
          :disabled="isClicked"
      >
        <div class="is-fullwidth next-button-content">
          <span class="button-text">Próximo</span>
          <span class="is-justify-content-end is-align-content-end has-text-right is-pulled-right">
            >
          </span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'next-button',
  data() {
    return {
      isClicked: false,
      isMobile: false
    }
  },
  props: {
    position: {
      required: true,
      type: String
    },
    sizeClass: {
      required: false,
      type: String
    }
  },
  methods: {
    handleClick() {
      // Emite o evento para avançar para a próxima tab
      this.$emit('nextTab')
      
      // Em dispositivos móveis, rola para o topo da página
      if (this.isMobile) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    checkIsMobile() {
      this.isMobile = window.innerWidth < 768
    }
  },
  mounted() {
    this.checkIsMobile()
    window.addEventListener('resize', this.checkIsMobile)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkIsMobile)
  }
}
</script>

<style scoped>
.next-button {
  padding: 0.75rem 1.5rem;
}

.next-button-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media screen and (max-width: 768px) {
  .next-button {
    padding: 0.5rem 1rem;
    height: auto;
  }
  
  .button-text {
    font-size: 1.1rem;
  }
}

@media screen and (max-width: 480px) {
  .next-button {
    padding: 0.4rem 0.8rem;
  }
  
  .button-text {
    font-size: 1rem;
  }
}
</style>